export var AlertableInteractionTypes;
(function (AlertableInteractionTypes) {
    AlertableInteractionTypes["voice"] = "voice";
})(AlertableInteractionTypes || (AlertableInteractionTypes = {}));
export var StreamingClientErrorTypes;
(function (StreamingClientErrorTypes) {
    StreamingClientErrorTypes["generic"] = "generic";
    StreamingClientErrorTypes["invalid_token"] = "invalid_token";
    StreamingClientErrorTypes["userCancelled"] = "user_cancelled";
})(StreamingClientErrorTypes || (StreamingClientErrorTypes = {}));
export var SessionTypes;
(function (SessionTypes) {
    SessionTypes["softphone"] = "softphone";
    SessionTypes["collaborateVideo"] = "collaborateVideo";
    SessionTypes["acdScreenShare"] = "screenShare";
    SessionTypes["screenRecording"] = "screenRecording";
    SessionTypes["liveScreenMonitoring"] = "liveScreenMonitoring";
    SessionTypes["unknown"] = "unknown";
})(SessionTypes || (SessionTypes = {}));
